/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export { HomePage } from "../components/pages/home";
export { PbPreview } from "../components/pages/pb-preview";
export { HomePagePreview } from "../components/pages/home-preview";
